import ads from './common/ads'
import { ready, registerCustomElement, supportsSelector, wait } from "./common/helpers"
import SGPlugins from "./common/SGPlugins"
import plugins from "./plugins"
import commonStyles from '../css/common.pcss.json'
import { initMessaging } from './common/cloud-messaging'
import './common/indexedDB'
import { sgConfirm } from "./plugins/SgAlert";
import { showDialog as show2FADialog } from "./plugins/manage-2fa";
import { authInit } from "./plugins/auth";

declare global {
  interface Window {
    isLoggedIn?: boolean,
    navigation: {
      activation: {
        from: {
          url: string
        }
        entry: {
          url: string
        }
      }
    }
  }
}

// noinspection JSUnusedGlobalSymbols
export let serviceWorkerRegistration: ServiceWorkerRegistration = null

async function index() {
  if ('serviceWorker' in navigator) {
    const version = process.env.RELEASE_VERSION
    navigator.serviceWorker.register('/service-worker.js?' + version)
      .then((registration) => {
        if (window.isLoggedIn) {
          return initMessaging(registration)
        }
      })
      .catch(() => {
        // Ну не установился ServiceWorker и ладно
        // captureException(e)
      })
  }

  if (window.matchMedia('(display-mode: standalone)').matches) {
    window.addEventListener('beforeunload', () => {
      const loader = document.createElement('div')
      loader.classList.add(commonStyles['page-loader'])
      document.body.append(loader)
      let width = 0
      const loadProgressInterval = setInterval(() => {
        width += 2;
        if (width > 90) {
          clearInterval(loadProgressInterval)
        }
        loader.setAttribute('style', `width: ${width}%`);
      }, 300)

      window.addEventListener('unload', () => {
        loader.setAttribute('style', 'width: 100%')
      })
    })

    window.addEventListener('load', async () => {
      if (document.querySelector(`.${commonStyles['page-loader']}`)) {
        const loader = document.querySelector(`.${commonStyles['page-loader']}`)
        await wait(200)
        loader.setAttribute('style', 'width: 100%')
        await wait(500)
        loader.classList.add(commonStyles['page-loader--fade-out'])
        await wait(300)
        loader.remove()
      }
    })
  }

  window.addEventListener('load', async () => {
    if (window.history.state !== null) {
      window.history.replaceState(null, '')
    }
  })

  // Get the scrollbar width
  const scrollbarWidth = Math.min(window.innerWidth - document.body.clientWidth, 10)
  const style = document.createElement('style')
  style.innerHTML = `:root { --scrollbar-width: ${scrollbarWidth}px; }`
  document.head.append(style)

  // Полифилим веб-компоненты в старых браузерах
  if (typeof customElements === 'undefined') {
    await import('@webcomponents/webcomponentsjs/bundles/webcomponents-ce')
    await import('@webcomponents/webcomponentsjs/bundles/webcomponents-sd-ce')
  }

  if (typeof HTMLFormElement.prototype.requestSubmit !== 'function') {
    await import('./libs/requestSubmitPolyfill').then(({ default: polyfill }) => polyfill())
  }

  if (!['production', 'beta'].includes(process.env.NODE_ENV)) {
    await import('./common/debug').then(({ default: debug }) => {
      debug()
    })
  }

  ready(async () => {
    // createConnection()
    plugins()
    registerCustomElement('sg-spoiler', './components/spoiler.js')
    registerCustomElement('styled-checkbox', './components/StyledCheckboxComponent.js')
    window.dispatchEvent(new CustomEvent('sg-idb-loaded'))

    SGPlugins.init()

    if (window.mandatory2fa) {
      sgConfirm('Двухфакторная авторизация обязательна для сотрудников Stopgame!', 'Включить')
        .then(result => {
          if (!result) {
            return
          }
          show2FADialog('enable')
        })
    }

    if (!supportsSelector('::-moz-range-progress')) {
      await import('./libs/rangePolyfill').then(({ default: polyfill }) => polyfill())
    }

    if (!window.isLoggedIn && window.location.hash.startsWith('#auth/')) {
      authInit()
    }

    if (typeof navigator.userAgent !== 'string' || navigator.userAgent.indexOf('Chrome-Lighthouse') === -1) {
      // @ts-ignore
      if (document.prerendering) {
        document.addEventListener("prerenderingchange", ads, {
          once: true
        });
      } else {
        ads();
      }
    }
  })
}

const logStyle = [
  `font-family: Rubik, sans-serif;
  font-size: 20px;
  font-weight: bold;
  color: red;`,
  `font-family: Roboto, sans-serif;`
]
console.log('%cStopGame.ru%c', ...logStyle, process.env.RELEASE_VERSION)
// noinspection JSIgnoredPromiseFromCall
index()
